<div class="ngtw-app fw fh">
    <router-outlet *ngIf="!isIframe"></router-outlet>
    <app-overlay-loader></app-overlay-loader>
</div>